Shopify.QuizResults = {

  storage: {

    data: null,

    collection: null,
    
    variantsData: null,

    results: null

  }, 

  elements: {

    quizResultsButton: function(product, variant, selected) {

      if (typeof product != "object") {
        return;
      }

      var productImage = product.images[0];
      var productSelected = selected == true ? 'quiz-result-product-button--selected' : "";
      var productId = product.id;
      var productTitle = product.title;

      var variantHTML = "";

      // console.log(variant);

      if (typeof variant != "undefined") {

        var variantTitle;

        if (variant.option1.indexOf("|")) {
          variantTitle = variant.option1.split("|")[0];
        }
        else {
          variantTitle = variant.option1;
        }

        variantHTML = `<p class="quiz-result-product-button__subtitle minor">${variantTitle}</p>`;
      }

      var html = `
      <button type="button" class="quiz-result-product-button ${productSelected}" data-id="${productId}" quiz-result-product-button>
        <div class="quiz-result-product-button__image">
          <img src="${productImage}" alt="${productTitle}">
        </div>
        <div class="quiz-result-product-button__meta">
          <p class="quiz-result-product-button__title">${productTitle}</p>
          ${variantHTML}
        </div>
      </button>`;

      return html;

    },

    quizResultsProduct: function(product, variant, selected) {

      if (typeof product != "object") {
        return;
      }

      var variantString = typeof variant != "undefined" ? '?variant=' + variant.id : "";

      var productId = product.id;
      var productSelected = selected == true ? 'quiz-results-product--selected' : "";
      var productURL = `/products/${product.handle}${variantString}`;
      var productViewURL = ``;

      if (productURL.indexOf("?") != -1) {
        productViewURL = `${productURL}&view=quiz-results-product`
      }
      else {
        productViewURL = `${productURL}?view=quiz-results-product`
      }

      var html = `
        <quiz-results-product href="${productViewURL}" class="quiz-results-product ${productSelected}" data-id="${productId}"></quiz-results-product>
      `;

      return html;

    }

  },

  functions: {

    addEventListeners: function(){

      document.querySelectorAll('[quiz-result-product-button]').forEach(element => {

        element.addEventListener("click", Shopify.QuizResults.eventHandlers.onClickProductButton);

      });

    },

    clearData: function() {

      localStorage.removeItem('quizData');

    },

    storeData: function() {

      var data = JSON.parse(localStorage.getItem('quizData'));

      if (typeof CustomerData != "undefined") {
        data.customer = {
          id: CustomerData.id
        };
      }

      localStorage.setItem('quizData', JSON.stringify(data));

    },

    validateQuizData: function(data) {

      // Basic validation function to check the data array used to submit data
      // to the back-end is well-formed.

      if (typeof data != "object") {
        return false;
      }

      if (typeof data.tags != "object") {
        return false;
      }

      if (!Array.isArray(data.tags)) {
        return false;
      }

      if (data.tags.length < 6) {
        return false;
      }

      return true;

    },

    extractResults: function() {

      /* ----- Get Answers from localStorage ----- */

      var data = JSON.parse(localStorage.getItem('quizData'));

      const answers = data.tags;
      const capsuleCollection = Shopify.QuizResults.storage.collection;

      var tagSkinTone;
      var tagSkinType;
      var tagEyes;
      var tagHair;
      var tagStyle;
      var tagTime;

      var capsuleTagFace = "Capsule:Face";
      var capsuleTagLips = "Capsule:Lips";
      var capsuleTagEyes = "Capsule: Eyes";
      var capsuleTagAccessories = "Capsule:Accessories";

      var numProductsFace = 1;
      var numProductsLips = 1;
      var numProductsEyes = 2;
      var numProductsAccessories = 2;

      var resultsArray = [];

      for (let index = 0; index < answers.length; index++) {

        const element = answers[index];

        if (element.tag.indexOf('Skin Tone:') != -1) {
          tagSkinTone = element;
          continue;
        } 
        else 
        if (element.tag.indexOf('Skin Type:') != -1) {
          tagSkinType = element;
          continue;
        }
        else 
        if (element.tag.indexOf('Eyes:') != -1) {
          tagEyes = element;
          continue;
        }
        else 
        if (element.tag.indexOf('Hair:') != -1) {
          tagHair = element;
          continue;
        }
        else 
        if (element.tag.indexOf('Style:') != -1) {
          tagStyle = element;
          continue;
        }
        else 
        if (element.tag.indexOf('Time:') != -1) {
          tagTime = element;
          continue;
        }

      }

      // console.log('tagSkinTone - ' + tagSkinTone.tagName);
      // console.log('tagSkinType - ' + tagSkinType.tagName);
      // console.log('tagEyes - ' + tagEyes.tagName);
      // console.log('tagHair - ' + tagHair.tagName);
      // console.log('tagStyle - ' + tagStyle.tagName);
      // console.log('tagTime - ' + tagTime.tagName);

      /* ----- Set Number of Results from Time tag  ----- */

      switch (tagTime.tagName) {
        case "5-10 Minutes":
          numProductsFace = 1;
          numProductsLips = 1;
          numProductsEyes = 2;
          numProductsAccessories = 2;
          break;
        
        case "10-20 Minutes":
          numProductsFace = 2;
          numProductsLips = 2;
          numProductsEyes = 3;
          numProductsAccessories = 3;
          break;
        
        case "20+ Minutes":
          numProductsFace = 3;
          numProductsLips = 3;
          numProductsEyes = 4;
          numProductsAccessories = 4;
          break;
      
        default:
          numProductsFace = 1;
          numProductsLips = 1;
          numProductsEyes = 2;
          numProductsAccessories = 2;

      }

      // console.log('numProductsFace - ' + numProductsFace);
      // console.log('numProductsLips - ' + numProductsLips);
      // console.log('numProductsEyes - ' + numProductsEyes);
      // console.log('numProductsAccessories - ' + numProductsAccessories);

      /* =============== Find Results  =============== */

      var capsuleCollectionFace = [];
      var capsuleCollectionLips = [];
      var capsuleCollectionEyes = [];
      var capsuleCollectionAccessories = [];

      for (let i = 0; i < capsuleCollection.length; i++) {

        console.log(i);
        
        var product = capsuleCollection[i];
        
        console.log(product.title);

        if (product.tags.includes(tagSkinType.tag)) {
          
          if (product.tags.includes(tagStyle.tag)) {

            console.log('inner - ' + i);

            if (product.tags.includes(capsuleTagFace)) {
              capsuleCollectionFace.push(product);
              continue;
            }
            if (product.tags.includes(capsuleTagLips)) {
              capsuleCollectionLips.push(product);
              continue;
            }
            if (product.tags.includes(capsuleTagEyes)) {
              capsuleCollectionEyes.push(product);
              continue;
            }
            if (product.tags.includes(capsuleTagAccessories)) {
              capsuleCollectionAccessories.push(product);
              continue;
            }

          }

        }
        
      }


      console.log(capsuleCollectionFace);
      console.log(capsuleCollectionLips);
      console.log(capsuleCollectionEyes);
      console.log(capsuleCollectionAccessories);

      // console.log("----- capsuleCollectionAll");
      // console.log(capsuleCollection);
      // console.log("----- capsuleCollectionFace");
      // console.log(capsuleCollectionFace);
      // console.log("----- capsuleCollectionLips");
      // console.log(capsuleCollectionLips);
      // console.log("----- capsuleCollectionEyes");
      // console.log(capsuleCollectionEyes);
      // console.log("----- capsuleCollectionAccessories");
      // console.log(capsuleCollectionAccessories);

      var addedProducts = 0;
      var breakloop = false;

      /* ----- FACE ----- */

      for (let r = 0; r <= numProductsFace; r++) {

        if (breakloop == true) {
          break;
        }

        for (let i = 0; i < capsuleCollectionFace.length; i++) {

          const product = capsuleCollectionFace[i];

          if (resultsArray.includes(product)) {
            continue;
          }
          else {
            resultsArray.push(product);
            addedProducts++;
            if (addedProducts == numProductsFace) {
              breakloop = true;
              break;
            }
          }

        }

      }

      /* ----- LIPS ----- */

      addedProducts = 0;
      breakloop = false;

      for (let r = 0; r <= numProductsLips; r++) {

        if (breakloop == true) {
          break;
        }

        for (let i = 0; i < capsuleCollectionLips.length; i++) {

          const product = capsuleCollectionLips[i];

          if (resultsArray.includes(product)) {
            continue;
          }
          else {
            resultsArray.push(product);
            addedProducts++;
            if (addedProducts == numProductsLips) {
              breakloop = true;
              break;
            }
          }

        }

      }

      /* ----- EYES ----- */
      
      addedProducts = 0;
      breakloop = false;

      console.log(capsuleCollectionEyes);

      for (let r = 0; r <= numProductsEyes; r++) {

        if (breakloop == true) {
          break;
        }

        console.log('EYES');
        console.log(r);

        for (let i = 0; i < capsuleCollectionEyes.length; i++) {

          const product = capsuleCollectionEyes[i];

          console.log(product.title);

          if (resultsArray.includes(product)) {
            continue;
          }
          else {
            resultsArray.push(product);
            addedProducts++;
            if (addedProducts == numProductsEyes) {
              breakloop = true;
              break;
            }
          }

        }

      }

      /* ----- ACCESSORIES ----- */

      // console.log("TEST LOOP");

      addedProducts = 0;
      breakloop = false;

      for (let r = 0; r <= numProductsAccessories; r++) {

        // console.log(r);

        for (let i = 0; i < capsuleCollectionAccessories.length; i++) {

          if (breakloop == true) {
            break;
          }

          const product = capsuleCollectionAccessories[i];

          if (resultsArray.includes(product)) {
            continue;
          }
          else {
            resultsArray.push(product);
            addedProducts++;
            if (addedProducts == numProductsAccessories) {
              breakloop = true;
              break;
            }
          }

        }

      }

      /* ----- Display Results  ----- */

      Shopify.QuizResults.storage.results = resultsArray;

    },

    displayResults: function() {

      var resultsArray = Shopify.QuizResults.storage.results;
      var resultsProductsHTML = "";
      var resultsNavigationHTML = "";

      for (let i = 0; i < resultsArray.length; i++) {
        
        const product = resultsArray[i];
        
        console.log('==========');
        console.log(product.title);
        console.log('----------');

        // console.log(product);
        
        const variant = Shopify.QuizResults.functions.getBestVariant(product)
        const selected = i == 0 ? true : false;

        resultsProductsHTML += Shopify.QuizResults.elements.quizResultsProduct(product, variant, selected);
        resultsNavigationHTML += Shopify.QuizResults.elements.quizResultsButton(product, variant, selected);
        
      }

      // console.log(resultsProductsHTML);
      // console.log(resultsNavigationHTML);
      
      document.querySelector('[data-quiz-navigation-container]').innerHTML = resultsNavigationHTML;
      document.querySelector('[data-quiz-products-container]').innerHTML = resultsProductsHTML;

    },

    getBestVariant: function(product) {

      var productId = product;

      var variantsData = Shopify.QuizResults.storage.variantsData;

      var variantID;

      var variants = product.variants;

      if (variants.length <= 1) {
        return;
      }

      var data = JSON.parse(localStorage.getItem('quizData'));

      const answers = data.tags;
      const capsuleCollection = Shopify.QuizResults.storage.collection;

      var tagSkinTone;
      var tagSkinType;
      var tagEyes;
      var tagHair;
      var tagStyle;
      var tagTime;

      for (let index = 0; index < answers.length; index++) {

        const element = answers[index];

        if (element.tag.indexOf('Skin Tone:') != -1) {
          tagSkinTone = element;
          continue;
        } 
        else 
        if (element.tag.indexOf('Skin Type:') != -1) {
          tagSkinType = element;
          continue;
        }
        else 
        if (element.tag.indexOf('Eyes:') != -1) {
          tagEyes = element;
          continue;
        }
        else 
        if (element.tag.indexOf('Hair:') != -1) {
          tagHair = element;
          continue;
        }
        else 
        if (element.tag.indexOf('Style:') != -1) {
          tagStyle = element;
          continue;
        }
        else 
        if (element.tag.indexOf('Time:') != -1) {
          tagTime = element;
          continue;
        }

      }

      var quizTags = [tagSkinTone, tagSkinType, tagEyes, tagHair, tagStyle, tagTime];

      // Weighting Variants

      var weightedVariants = [];

      // console.log(variants);

      for (let i = 0; i < variants.length; i++) {

        const variant = variants[i];

        // console.log(variant.title);
        
        var dataVariant;
        var dataTags;

        // Get Metafields
        for (let p = 0; p < variantsData.length; p++) {
          const dvProduct = variantsData[p];
          if (product.id == dvProduct.id) {
            for (let dv = 0; dv < dvProduct.variants.length; dv++) {
              const dvVariant = dvProduct.variants[dv];
              if (dvVariant.id == variant.id) {
                dataMetafields = dvVariant.tags;
                break;
              }
            }
            break;
          }
        }

        if (typeof dataMetafields != "undefined" && dataMetafields !== "") {
          dataTags = dataMetafields.split(", ");
        }
        else {
          continue;
        }

        // console.log('-----');
        // console.log(variant.title);
        // console.log(dataMetafields);
        // console.log(dataTags);

        let weight = 0;

        for (let v = 0; v < dataTags.length; v++) {
          const tag = dataTags[v];
          for (let t = 0; t < quizTags.length; t++) {

            const quizTag = quizTags[t].tag;
            // console.log(tag + ' - ' + quizTag);
            if (tag == quizTag) {
              // console.log('MATCH');
              weight++;
            }
          }
        }

        weightedVariants.push({ variant: variant, weight: weight});
        
      }

      // console.log(weightedVariants);

      var highestVariant;
      var highestVariantWeight = 0;

      for (let w = 0; w < weightedVariants.length; w++) {
        
        const element = weightedVariants[w];

        console.log(weightedVariants[w].variant.title + ' ' + weightedVariants[w].weight);

        if (element.weight > highestVariantWeight) {
          highestVariant = element;
          highestVariantWeight = element.weight;
        }

      }

      // console.log(highestVariant);

      if (typeof highestVariant == 'undefined') {
        return;
      }

      if (typeof highestVariant.variant != 'undefined') {
        return highestVariant.variant;
      }
      else {
        return;
      }

    }

  },

  eventHandlers: {

    onClickProductButton: function(e) {

      let productButton = e.currentTarget;
      let productButtons = document.querySelectorAll('[quiz-result-product-button]');

      let id = productButton.dataset.id;

      let productResults = document.querySelectorAll('.quiz-results-product');
      let productResult = document.querySelector('.quiz-results-product[data-id="' + id + '"]');

      productButtons.forEach(element => {
        element.classList.remove("quiz-result-product-button--selected");
      });

      productResults.forEach(element => {
        element.classList.remove("quiz-results-product--selected");
      });

      productButton.classList.add("quiz-result-product-button--selected");
      productResult.classList.add("quiz-results-product--selected");

    }

  },

  init: function() {

    Shopify.QuizResults.storage.collection = JSON.parse(document.querySelector('[data-capsule-collection-data]').dataset.capsuleCollectionData);
    Shopify.QuizResults.storage.variantsData = JSON.parse(document.querySelector('[data-capsule-collection-data]').dataset.capsuleVariantsData);

    Shopify.QuizResults.functions.storeData();

    Shopify.QuizResults.functions.extractResults();
    Shopify.QuizResults.functions.displayResults();

    Shopify.QuizResults.functions.addEventListeners();

  }

};

document.addEventListener("DOMContentLoaded", function(){
  Shopify.QuizResults.init();
});